/* 🤖 this file was generated by svg-to-ts*/

export type IconName =
  | 'academic-multi'
  | 'academic'
  | 'add-address'
  | 'add-credit-card'
  | 'add-direct-debit'
  | 'amex-branded'
  | 'android'
  | 'angular'
  | 'apple'
  | 'apple-pay'
  | 'apps'
  | 'archive-filled'
  | 'archive'
  | 'arrow-down-circle-filled'
  | 'arrow-down-circle'
  | 'arrow-down'
  | 'arrow-left-circle-filled'
  | 'arrow-left-circle'
  | 'arrow-left'
  | 'arrow-right-circle-filled'
  | 'arrow-right-circle'
  | 'arrow-right'
  | 'arrow-up-circle-filled'
  | 'arrow-up-circle'
  | 'arrow-up'
  | 'attachement'
  | 'bookmark-add-filled'
  | 'bookmark-add'
  | 'bookmark-delete-filled'
  | 'bookmark-delete'
  | 'bookmark-filled'
  | 'bookmark'
  | 'bookmarks-filled'
  | 'bookmarks'
  | 'bug-filled'
  | 'bug'
  | 'calendar'
  | 'caret-double-horizontal'
  | 'caret-double-vertical'
  | 'caret-down'
  | 'caret-left'
  | 'caret-right'
  | 'caret-up'
  | 'change'
  | 'chart-bar-filled'
  | 'chart-bar'
  | 'chart-line'
  | 'chart-pie-filled'
  | 'chart-pie'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'clipboard-filled'
  | 'clipboard-task-filled'
  | 'clipboard-task'
  | 'clipboard'
  | 'cloud-download'
  | 'cloud-off'
  | 'cloud-outline'
  | 'cloud-upload'
  | 'cloud'
  | 'code-alt'
  | 'code-curly'
  | 'code'
  | 'cog'
  | 'comment-add-filled'
  | 'comment-add'
  | 'comment-filled'
  | 'comment-warning-filled'
  | 'comment-warning'
  | 'comment'
  | 'copy'
  | 'credit-card-validator-error'
  | 'credit-card-validator-neutral'
  | 'credit-card'
  | 'cross-circle-filled'
  | 'cross-circle'
  | 'cross'
  | 'cross-check-duo'
  | 'css-3'
  | 'database-filled'
  | 'database'
  | 'delete-filled'
  | 'delete-key-outline'
  | 'delete-key'
  | 'delete'
  | 'discount'
  | 'dot'
  | 'eclipse-branded'
  | 'eclipse'
  | 'edit-field'
  | 'edit'
  | 'envelope-filled'
  | 'envelope'
  | 'error'
  | 'expired-duo'
  | 'export'
  | 'facebook'
  | 'file-add-filled'
  | 'file-add'
  | 'file-filled'
  | 'file-remove-filled'
  | 'file-remove'
  | 'file'
  | 'filter'
  | 'flag-filled'
  | 'flag'
  | 'folder-add-filled'
  | 'folder-add'
  | 'folder-closed-fillled'
  | 'folder-closed'
  | 'folder-open-filled'
  | 'folder-open'
  | 'folder-remove-filled'
  | 'folder-remove'
  | 'forbidden'
  | 'git-branch'
  | 'git-commit'
  | 'git-compare'
  | 'git-fork'
  | 'git-merge'
  | 'git-pull'
  | 'git'
  | 'github'
  | 'globe'
  | 'google'
  | 'google-pay'
  | 'heart-filled'
  | 'heart'
  | 'help-circle-filled'
  | 'help-circle'
  | 'history'
  | 'home-filled'
  | 'home'
  | 'html-5'
  | 'image-filled'
  | 'image'
  | 'import'
  | 'info-circle-filled'
  | 'information-sign-duo'
  | 'info-circle'
  | 'issue-circle-filled'
  | 'issue-circle'
  | 'javascript'
  | 'launcher-branded'
  | 'less'
  | 'link-external'
  | 'link'
  | 'linkedin'
  | 'linux'
  | 'loader-dark'
  | 'loader-light'
  | 'loading-line'
  | 'location-filled'
  | 'location'
  | 'lock-closed-filled'
  | 'lock-closed'
  | 'lock-open-filled'
  | 'lock-open'
  | 'logged-in'
  | 'mastercard-branded'
  | 'maximize'
  | 'medium'
  | 'menu'
  | 'microsoft'
  | 'minimize'
  | 'minus-circle'
  | 'minus-small'
  | 'minus'
  | 'moon-filled'
  | 'moon'
  | 'more-horizontal'
  | 'more-vertical'
  | 'multi-user'
  | 'notification-filled'
  | 'notification'
  | 'office'
  | 'organization'
  | 'paypal-branded'
  | 'paypal'
  | 'performance-filled'
  | 'performance'
  | 'person'
  | 'persons'
  | 'play-filled'
  | 'play'
  | 'plus-circle-filled'
  | 'plus-circle'
  | 'plus'
  | 'react'
  | 'redo'
  | 'refresh'
  | 'rocket-filled'
  | 'rocket'
  | 'sass'
  | 'search'
  | 'send'
  | 'settings'
  | 'share-filled'
  | 'share'
  | 'shopping-cart'
  | 'sign-in'
  | 'sign-out'
  | 'single-user'
  | 'stack-filled'
  | 'stack'
  | 'stackoverflow'
  | 'star-filled'
  | 'star'
  | 'student'
  | 'subscription-duo'
  | 'sun-filled'
  | 'sun'
  | 'tag-filled'
  | 'tag'
  | 'target'
  | 'teacher'
  | 'terminal-filled'
  | 'terminal'
  | 'tick-circle-filled'
  | 'tick-circle'
  | 'tick-small'
  | 'tick'
  | 'time'
  | 'trending-down'
  | 'trending-up'
  | 'twitter'
  | 'uml-lab'
  | 'undo'
  | 'user-circle-1'
  | 'user-circle-2'
  | 'user-circle-filled'
  | 'user-filled'
  | 'user-group'
  | 'user'
  | 'verified'
  | 'view-disabled'
  | 'view-enabled'
  | 'visa-branded'
  | 'vscode'
  | 'vuejs'
  | 'x-circle-duo'
  | 'warning-filled'
  | 'warning'
  | 'windows'
  | 'wrench'
  | 'yatta-branded'
  | 'yatta-logo'
  | 'yatta-logo-white'
  | 'yatta'
  | 'youtube'
  | 'zap'
  | 'zoom-in-filled'
  | 'zoom-in'
  | 'zoom-out-filled'
  | 'zoom-out'
  | 'mail'
  | 'building-duo'
  | 'box-duo'
  | 'code-duo'
  | 'key-duo'
  | 'signed-in'
  | 'logout-duo'
  | 'edit-field-duo'
  | 'delete-duo'
  | 'info-duo'
  | 'plus-circle-duo'
  | 'add-credit-card-duo'
  | 'add-credit-card-duo-outline'
  | 'add-direct-debit-duo'
  | 'add-direct-debit-duo-outline'
  | 'paypal-branded-duo'
  | 'paypal-branded-duo-outline'
  | 'add-product-duo'
  | 'add-user-duo'
  | 'analytics-duo'
  | 'arrow-down-circle-duo'
  | 'arrow-left-circle-duo'
  | 'arrow-right-circle-duo'
  | 'arrow-up-circle-duo'
  | 'billing-info-duo'
  | 'calendar-duo'
  | 'cog-duo'
  | 'cross-circle-duo'
  | 'flag-duo'
  | 'group-add-duo'
  | 'group-verified-duo'
  | 'home-duo'
  | 'link-external-duo'
  | 'lock-closed-duo'
  | 'lock-open-duo'
  | 'refresh-duo'
  | 'remove-user-duo'
  | 'sign-out-duo'
  | 'stack-duo'
  | 'tick-circle-duo'
  | 'user-circle-duo'
  | 'user-duo'
  | 'user-group-duo'
  | 'verified-duo'
  | 'warning-duo'
  | 'zoom-in-duo'
  | 'zoom-out-duo'
  | 'translate-duo'
  | 'sign-out-duo'
  | 'student-duo'
  | 'teacher-duo'
  | 'organization-duo'
  | 'time-duo'
  | 'location-start-duo'
  | 'location-pin-duo'
  | 'sepa'
  | 'apple-pay-card'
  | 'google-pay-card';
export interface Icon {
  name: IconName;
  data: string;
}
